const rgb = (hex) => {
    const h = (hex || "#1a1a1a").replace("#", "");
    const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};
const chan = (v) => { const c = v / 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4; };
const lum = ([r, g, b]) => 0.2126 * chan(r) + 0.7152 * chan(g) + 0.0722 * chan(b);
const ratio = (a, b) => { const [x, y] = [lum(a), lum(b)].sort((p, q) => q - p); return (x + 0.05) / (y + 0.05); };
const hex = (c) => `#${c.map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0")).join("")}`;

const WHITE = [255, 255, 255];
const INK = [26, 26, 26];

/** 1A.1 contrast rule: white or #1a1a1a on the shop color at 4.5:1, else darken the accent 5% at a time. */
export function accentPair(primary) {
    let c = rgb(primary);
    if (ratio(c, WHITE) >= 4.5) return { accent: hex(c), on: "#ffffff" };
    if (ratio(c, INK) >= 4.5) return { accent: hex(c), on: "#1a1a1a" };
    let guard = 0;
    while (ratio(c, WHITE) < 4.5 && guard++ < 40) c = c.map((v) => v * 0.95);
    return { accent: hex(c), on: "#ffffff" };
}
